import injectSheet from 'react-jss';
export const styles = {
  main: {
    width: 'calc(100% - 628px)', // 294+334
    backgroundColor: 'rgb(250, 250, 250)',
  },
  semitransparent: {
    opacity: '0.5',
  },
  hidden: {
    display: 'none',
  },
  title: {
    color: 'white',
    fontSize: '18px',
    width: '100%',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 161, 186)',
  },
  body: {
    padding: '13px',
    height: 'calc(100% - 48px)',
    overflowY: 'auto',
    position: 'relative',
  },
  sentData: {
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  firstCard: {
    marginBottom: '20px',
  },
  flexItem: {
    flexGrow: 1,
    flexBasis: 0,
    // minWidth: '250px',
    // maxWidth: '250px',
    '&.centerText': {
      textAlign: 'center',
    },
  },
  headerIcon: {
    color: 'rgb(0, 179, 207) !important',
    lineHeight: '20px',
    marginRight: '12px',
  },
  headerContainer: {
    color: '#616061 !important',
    '&>div': {
      width: '100%',
    },
  },
  cardHeader: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    color: '#616061 !important',
    margin: '0 0 0 16px',
  },
  cardText: {
    color: '#616061 !important',
  },
  cardTextMessage: {
    color: '#616061 !important',
    padding: '0 60px 16px 60px !important',
    '&>p': {
      color: '#616061 !important',
      fontSize: '13px !important',
    },
  },
  cardTextTitle: {
    borderBottom: '1px solid #dadada',
    paddingBottom: '6px',
    marginBottom: '0',
  },
  titleStart: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  messageRowDelivered: {
    textAlign: 'right',
    paddingRight: '30px',
  },
  partnerRow: {
    display: 'flex',
    flexWrap: 'nowrap',
    color: '#616061 !important',
  },
  partnerRowPartnerInfo: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  partnerRowCompanyName: {
    lineHeight: '40px',
    marginLeft: '12px',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'noWrap',
    width: '350px',
  },
  partnerRowcontacts: {
    lineHeight: '40px',
    textAlign: 'right',
    marginLeft: '24px',
  },
  partnerRowStatus: {
    display: 'flex',
    flexWrap: 'nowrap',
    lineHeight: '40px',
    justifyContent: 'center',
    marginLeft: '24px',
  },
  partnerRowStatusIcon: {
    marginTop: '12px',
    marginRight: '6px',
    fontSize: '17px !important',
    svgSize: 17,
  },
  userRowStatusIcon: {
    marginTop: '0',
    marginRight: '4px',
    fontSize: '12px !important',
    svgSize: 12,
  },
  tableBody: {
    '&>tr>td': {
      color: '#616061 !important',
    },
  },
  serchBox: {
    height: '35px',
  },
  messageBody: {
    marginTop: '12px',
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '1em',
    overflowX: 'hidden',
    whiteSpace: 'pre-wrap',
    width: '100%',
  },
  fileAttachment: {
    marginTop: '16px',
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: '4px !important',
    '&>span': {
      color: '#616061 !important',
      fontSize: '13px !important',
    },
  },
  attachmentIcon: {
    fontSize: '19px !important',
  },
};
export default (component) => injectSheet(styles)(component);



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/workspace/body.css.js